import React from 'react';
import FontAwesome from 'react-fontawesome';
import { Content, Box } from 'reactjs-admin-lte';
import { Button } from 'react-bootstrap';
import Pagination from 'components/core/Pagination';
import NGWordFilter from './NGWordFilter';
import NGWordTable from './NGWordTable';

const NGWord = (props) => {

  const {
    ngWords,
    pageSize,
    currentPage,
    isLoading,
    client,
    keyword,
    language,
    languageOptions,
    selected,
    handleSelect,
    handleSubmit,
    handlePageSelect,
    handleKeywordChange,
    handleLanguageChange,
    handleClientChange,
    handleDelete,
    showAddModal
  } = props;

  return (
    <Content.Body>
      <NGWordFilter
        client={client}
        keyword={keyword}
        language={language}
        languageOptions={languageOptions}
        handleSubmit={handleSubmit}
        handleKeywordChange={handleKeywordChange}
        handleClientChange={handleClientChange}
        handleLanguageChange={handleLanguageChange} />
      <div className="clearfix">
        <Button
          bsStyle="danger"
          bsSize="sm"
          type="button"
          className="mb-10 pull-right"
          disabled={selected.length === 0}
          onClick={handleDelete}>
          <FontAwesome name="times-circle" className="mr-5" />Delete
        </Button>
      </div>
      <Box
        className="box-widget mb-0"
        loading={isLoading}>
        <Box.Body noPadding={true}>
          <NGWordTable
            ngWords={ngWords}
            selected={selected}
            handleSelect={handleSelect} />
        </Box.Body>
        <Box.Footer>
          <Button
            type="button"
            bsStyle="primary"
            onClick={showAddModal}>
            <FontAwesome name="plus" className="mr-5" />Add New NG Word
          </Button>
          <Pagination
            currentPage={currentPage}
            totalPages={pageSize}
            onChange={handlePageSelect} />
        </Box.Footer>
      </Box>
    </Content.Body>
  )
}

export default NGWord;